import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import {addUniqueCssClasses} from "@functions/css";
import {isDetailsMode, useFormMode} from "@contexts/FormModeContext";

export function WizardStepButtonsBlock({
   onPrevBtnClick,
   onNextBtnClick,
   prevBtnText = 'Previous',
   nextBtnText = 'Next',
   nextBtnIconClass = 'fa fa-fw fa-chevron-right',
   nextBtnIconPosition = 'right',
   isNextBtnDisabled = false,
   nextButtonAdditionalCssClass = '',
   showPrevBtn = true,
   showNextBtn = true,
}) {
   
   const {mode} = useFormMode();
   
   if(isDetailsMode(mode)) {
      return null;
   }
   
   if (nextBtnIconPosition === 'left') {
      nextBtnIconClass = addUniqueCssClasses(nextBtnIconClass, 'me-2');
   } else {
      nextBtnIconClass = addUniqueCssClasses(nextBtnIconClass, 'ms-2');
   }
   
   const buttonRowAlignment = showPrevBtn ? 'justify-content-between' : 'justify-content-end';

   return (
      <div className="row mt-4 pt-2">
         <div className={`col d-flex ${buttonRowAlignment}`}>
            
            {showPrevBtn && (
               <PreviousButtonComponent
                  text={prevBtnText}
                  onClick={onPrevBtnClick}
               />
            )}
            
            {showNextBtn && (
               <NextButtonComponent
                  text={nextBtnText}
                  onClick={onNextBtnClick}
                  iconClass={nextBtnIconClass}
                  iconPosition={nextBtnIconPosition}
                  disabled={isNextBtnDisabled}
                  additionalCssClasses={nextButtonAdditionalCssClass}
               />
            )}
         
         </div>
      </div>
   )
   
}